module.exports = __webpack_public_path__ + "static/img/team-bg2.489b89c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team-bg2.png
// module id = AWHw
// module chunks = 36